import { IStorageMemoryDedicated } from "namirasoft-core";
import { BaseFinalCommand } from "namirasoft-node-cli";
import { TokenManager } from "../TokenManager";
import { NamirasoftAccountServer } from "../NamirasoftAccountServer";

export class AccountLogoutCommand extends BaseFinalCommand
{
    constructor(argv: string[])
    {
        super(argv, [], []);
    }
    override async exec()
    {
        let token = this.app.storage.getNSAToken();
        if (token != null)
        {
            let storage = new IStorageMemoryDedicated();
            let manager = new TokenManager(storage, () => { });
            manager.setText(token, false);
            let url = this.app.storage.getItem("ns-account-server-url");
            let server = new NamirasoftAccountServer(url, manager, e => this.app.logger.error(e.message));
            await server.session.Logout();
            this.app.storage.setNSAToken("");
        }
    }
};